/*
 * @Author: Admni
 * @Description: 
 * @Date: 2020-07-14 14:07:10
 * @LastEditTime: 2020-11-17 16:38:43
 */
import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getter'
import user from './modules/user'
import app from './modules/app'
import permission from './modules/permission'

Vue.use(Vuex)

export default new Vuex.Store({
  getters,
  modules: {
    app,
    user,
    permission
  }
})
